import { palette } from '../global/palette';
import type { ComponentOverride } from '../types';
import ExpandDownModule from '@tdcerhverv/parrotfish/icons/ExpandDown';
import { icon } from '../../utils/interop';

const Expand_down = icon(ExpandDownModule);
import { outlinedInputClasses } from '@mui/material';

export const MuiSelect: ComponentOverride<'MuiSelect'> = {
  MuiSelect: {
    styleOverrides: {
      select: {
        minWidth: 80,
        '&:focus': {
          backgroundColor: palette.common.white,
        },
        [`&.${outlinedInputClasses.input}`]: {
          paddingRight: 48,
        },
      },
      icon: {
        top: 'unset',
        fill: palette.common.black,
        '&$disabled': {
          fill: palette.grey[400],
        },
      },
      iconOutlined: {
        right: 16,
        width: 16,
      },
    },
    defaultProps: {
      IconComponent: Expand_down,
    },
  },
};
